/**
 * This code was AUTOGENERATED using the codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getDiscriminatedUnionDecoder,
  getDiscriminatedUnionEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
  type GetDiscriminatedUnionVariant,
  type GetDiscriminatedUnionVariantContent,
} from '@solana/kit';
import {
  getEquatableOperatorDecoder,
  getEquatableOperatorEncoder,
  getIntegerOperatorDecoder,
  getIntegerOperatorEncoder,
  type EquatableOperator,
  type EquatableOperatorArgs,
  type IntegerOperator,
  type IntegerOperatorArgs,
} from '.';

export type MetaAssertion =
  | { __kind: 'RentExemptReserve'; value: bigint; operator: IntegerOperator }
  | { __kind: 'AuthorizedStaker'; value: Address; operator: EquatableOperator }
  | {
      __kind: 'AuthorizedWithdrawer';
      value: Address;
      operator: EquatableOperator;
    }
  | { __kind: 'LockupUnixTimestamp'; value: bigint; operator: IntegerOperator }
  | { __kind: 'LockupEpoch'; value: bigint; operator: IntegerOperator }
  | { __kind: 'LockupCustodian'; value: Address; operator: EquatableOperator };

export type MetaAssertionArgs =
  | {
      __kind: 'RentExemptReserve';
      value: number | bigint;
      operator: IntegerOperatorArgs;
    }
  | {
      __kind: 'AuthorizedStaker';
      value: Address;
      operator: EquatableOperatorArgs;
    }
  | {
      __kind: 'AuthorizedWithdrawer';
      value: Address;
      operator: EquatableOperatorArgs;
    }
  | {
      __kind: 'LockupUnixTimestamp';
      value: number | bigint;
      operator: IntegerOperatorArgs;
    }
  | {
      __kind: 'LockupEpoch';
      value: number | bigint;
      operator: IntegerOperatorArgs;
    }
  | {
      __kind: 'LockupCustodian';
      value: Address;
      operator: EquatableOperatorArgs;
    };

export function getMetaAssertionEncoder(): Encoder<MetaAssertionArgs> {
  return getDiscriminatedUnionEncoder([
    [
      'RentExemptReserve',
      getStructEncoder([
        ['value', getU64Encoder()],
        ['operator', getIntegerOperatorEncoder()],
      ]),
    ],
    [
      'AuthorizedStaker',
      getStructEncoder([
        ['value', getAddressEncoder()],
        ['operator', getEquatableOperatorEncoder()],
      ]),
    ],
    [
      'AuthorizedWithdrawer',
      getStructEncoder([
        ['value', getAddressEncoder()],
        ['operator', getEquatableOperatorEncoder()],
      ]),
    ],
    [
      'LockupUnixTimestamp',
      getStructEncoder([
        ['value', getI64Encoder()],
        ['operator', getIntegerOperatorEncoder()],
      ]),
    ],
    [
      'LockupEpoch',
      getStructEncoder([
        ['value', getU64Encoder()],
        ['operator', getIntegerOperatorEncoder()],
      ]),
    ],
    [
      'LockupCustodian',
      getStructEncoder([
        ['value', getAddressEncoder()],
        ['operator', getEquatableOperatorEncoder()],
      ]),
    ],
  ]);
}

export function getMetaAssertionDecoder(): Decoder<MetaAssertion> {
  return getDiscriminatedUnionDecoder([
    [
      'RentExemptReserve',
      getStructDecoder([
        ['value', getU64Decoder()],
        ['operator', getIntegerOperatorDecoder()],
      ]),
    ],
    [
      'AuthorizedStaker',
      getStructDecoder([
        ['value', getAddressDecoder()],
        ['operator', getEquatableOperatorDecoder()],
      ]),
    ],
    [
      'AuthorizedWithdrawer',
      getStructDecoder([
        ['value', getAddressDecoder()],
        ['operator', getEquatableOperatorDecoder()],
      ]),
    ],
    [
      'LockupUnixTimestamp',
      getStructDecoder([
        ['value', getI64Decoder()],
        ['operator', getIntegerOperatorDecoder()],
      ]),
    ],
    [
      'LockupEpoch',
      getStructDecoder([
        ['value', getU64Decoder()],
        ['operator', getIntegerOperatorDecoder()],
      ]),
    ],
    [
      'LockupCustodian',
      getStructDecoder([
        ['value', getAddressDecoder()],
        ['operator', getEquatableOperatorDecoder()],
      ]),
    ],
  ]);
}

export function getMetaAssertionCodec(): Codec<
  MetaAssertionArgs,
  MetaAssertion
> {
  return combineCodec(getMetaAssertionEncoder(), getMetaAssertionDecoder());
}

// Data Enum Helpers.
export function metaAssertion(
  kind: 'RentExemptReserve',
  data: GetDiscriminatedUnionVariantContent<
    MetaAssertionArgs,
    '__kind',
    'RentExemptReserve'
  >
): GetDiscriminatedUnionVariant<
  MetaAssertionArgs,
  '__kind',
  'RentExemptReserve'
>;
export function metaAssertion(
  kind: 'AuthorizedStaker',
  data: GetDiscriminatedUnionVariantContent<
    MetaAssertionArgs,
    '__kind',
    'AuthorizedStaker'
  >
): GetDiscriminatedUnionVariant<
  MetaAssertionArgs,
  '__kind',
  'AuthorizedStaker'
>;
export function metaAssertion(
  kind: 'AuthorizedWithdrawer',
  data: GetDiscriminatedUnionVariantContent<
    MetaAssertionArgs,
    '__kind',
    'AuthorizedWithdrawer'
  >
): GetDiscriminatedUnionVariant<
  MetaAssertionArgs,
  '__kind',
  'AuthorizedWithdrawer'
>;
export function metaAssertion(
  kind: 'LockupUnixTimestamp',
  data: GetDiscriminatedUnionVariantContent<
    MetaAssertionArgs,
    '__kind',
    'LockupUnixTimestamp'
  >
): GetDiscriminatedUnionVariant<
  MetaAssertionArgs,
  '__kind',
  'LockupUnixTimestamp'
>;
export function metaAssertion(
  kind: 'LockupEpoch',
  data: GetDiscriminatedUnionVariantContent<
    MetaAssertionArgs,
    '__kind',
    'LockupEpoch'
  >
): GetDiscriminatedUnionVariant<MetaAssertionArgs, '__kind', 'LockupEpoch'>;
export function metaAssertion(
  kind: 'LockupCustodian',
  data: GetDiscriminatedUnionVariantContent<
    MetaAssertionArgs,
    '__kind',
    'LockupCustodian'
  >
): GetDiscriminatedUnionVariant<MetaAssertionArgs, '__kind', 'LockupCustodian'>;
export function metaAssertion<K extends MetaAssertionArgs['__kind'], Data>(
  kind: K,
  data?: Data
) {
  return Array.isArray(data)
    ? { __kind: kind, fields: data }
    : { __kind: kind, ...(data ?? {}) };
}

export function isMetaAssertion<K extends MetaAssertion['__kind']>(
  kind: K,
  value: MetaAssertion
): value is MetaAssertion & { __kind: K } {
  return value.__kind === kind;
}
